import React, { useState } from 'react';
import graphictwo from '../../../assets/graphic2.png';
import { motion } from "framer-motion"
import {Helmet} from "react-helmet";

const Aboutme = () => {

     const [isLoaded, setIsLoaded] = useState(false);
     const [isInView, setIsInView] = useState(false);

     const hiddenMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 30px, rgba(0,0,0,1) 30px, rgba(0,0,0,1) 30px)`;
     const visibleMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 0px, rgba(0,0,0,1) 0px, rgba(0,0,0,1) 30px)`;

    return (
        <div className="p-4 sm:ml-20 lg:ml-48 md:ml-36 bg-gray-900">
        <Helmet>
        <title>About Me</title>
        <meta name='portfolio' content='Mahabuba akter morsana - My Bio' />
        </Helmet>
        <div className="p-6">
           <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-4 lg:mt-6 mt-4 items-center">
              <div className='rounded text-left leading-relaxed'>
              <p className='text-[#976DB2] text-4xl mb-5'>ABOUT ME</p>
              <p className='text-gray-50 text-md'>I am Mahabuba Akter Morsana, I have completed Bachelor degree in Computer Science and Engineering from Barishal University. Proven ability to design and develop visually appealing and user-friendly websites and applications. Expertise in a variety of design software, including 𝗔𝗱𝗼𝗯𝗲 𝗣𝗵𝗼𝘁𝗼𝘀𝗵𝗼𝗽, 𝗜𝗹𝗹𝘂𝘀𝘁𝗿𝗮𝘁𝗼𝗿, and 𝗔𝗳𝘁𝗲𝗿 𝗘𝗳𝗳𝗲𝗰𝘁𝘀. Strong coding skills in 𝗛𝗧𝗠𝗟, 𝗖𝗦𝗦, and 𝗝𝗮𝘃𝗮𝗦𝗰𝗿𝗶𝗽𝘁. Excellent communication and teamwork skills. Ability to work independently and as part of a team. Passionate about creating innovative and user-centered design solutions.
              <br /> <br />
              ⦾ 𝘗𝘳𝘰𝘨𝘳𝘢𝘮𝘮𝘪𝘯𝘨 𝘓𝘢𝘯𝘨𝘶𝘢𝘨𝘦: 𝗝𝗮𝘃𝗮𝗦𝗰𝗿𝗶𝗽𝘁, 𝗖/𝗖++. <br/>
⦾ 𝘍𝘳𝘰𝘯𝘵-𝘌𝘯𝘥 𝘛𝘦𝘤𝘩𝘯𝘰𝘭𝘰𝘨𝘺: 𝗛𝘁𝗺𝗹, 𝗖𝗦𝗦, 𝗕𝗼𝗼𝘁𝘀𝘁𝗿𝗮𝗽 𝗮𝗻𝗱 𝗧𝗮𝗶𝗹𝘄𝗶𝗻𝗱 𝗖𝗦𝗦. <br/>
⦾ 𝘍𝘳𝘰𝘯𝘵-𝘌𝘯𝘥 𝘓𝘪𝘣𝘳𝘢𝘳𝘺: 𝗥𝗲𝗮𝗰𝘁 𝗷𝘀, 𝗡𝗲𝘅𝘁 𝗷𝘀. <br/>
⦾ 𝘉𝘢𝘤𝘬-𝐸𝑛𝑑 𝘛𝘦𝘤𝘩𝘯𝘰𝘭𝘰𝘨𝘺: 𝗡𝗼𝗱𝗲 𝗷𝘀, 𝗘𝘅𝗽𝗿𝗲𝘀𝘀 𝗷𝘀.<br/>
⦾ 𝘋𝘢𝘵𝘢𝘣𝘢𝘴𝘦: 𝗠𝗼𝗻𝗴𝗼𝗗𝗕, 𝗠𝘆𝗦𝗤𝗟.<br/>
⦾ 𝘝𝘦𝘳𝘴𝘪𝘰𝘯 𝘊𝘰𝘯𝘵𝘳𝘰𝘭 𝘚𝘺𝘴𝘵𝘦𝘮: 𝗚𝗶𝘁, 𝗚𝗶𝘁𝗵𝘂𝗯.<br/>
⦾ 𝘗𝘳𝘰𝘥𝘶𝘤𝘵𝘪𝘷𝘪𝘵𝘺 𝘛𝘰𝘰𝘭𝘴 𝘧𝘰𝘳 𝘊𝘰𝘯𝘵𝘦𝘯𝘵: 𝗪𝗼𝗿𝗱, 𝗘𝘅𝗰𝗲𝗹, 𝗣𝗼𝘄𝗲𝗿𝗣𝗼𝗶𝗻𝘁.<br/>
⦾ 𝘎𝘳𝘢𝘱𝘩𝘪𝘤 𝘋𝘦𝘴𝘪𝘨𝘯 𝘛𝘰𝘰𝘭𝘴: 𝗔𝗱𝗼𝗯𝗲 𝗣𝗵𝗼𝘁𝗼𝘀𝗵𝗼𝗽, 𝗜𝗹𝗹𝘂𝘀𝘁𝗿𝗮𝘁𝗼𝗿.
</p>
              </div>
              <motion.div
              className="flex items-center justify-center rounded"
               initial={false}
               animate={
                   isLoaded && isInView
                     ? { WebkitMaskImage: visibleMask, maskImage: visibleMask }
                     : { WebkitMaskImage: hiddenMask, maskImage: hiddenMask }
               }
               transition={{ duration: 0.5, delay: 0.5 }}
               viewport={{ once: true }}
               onViewportEnter={() => setIsInView(true)}
               >
               <img className="sm:w-80 lg:w-full md:w-96" src={graphictwo} alt="" onLoad={() => setIsLoaded(true)} />
               </motion.div>
           </div>
        </div>
     </div>
    );
};

export default Aboutme;